import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateGeneric = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 498.09 493.26",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:none;}.d{fill:#ebf3ff;}.e{fill:#fafcff;}.f{fill:#9ec5ff;}.g{fill:#b5c5ea;}.h{fill:#dcebfe;}.i{opacity:.15;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "e",
				cx: 246.8,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M401.19,101.49H162.89c-6.9,0-12.5,5.6-12.5,12.5V380.34H413.7V113.99c0-6.9-5.6-12.5-12.5-12.5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "c",
					d: "M401.19,101.49H162.89c-6.9,0-12.5,5.6-12.5,12.5V380.34H413.7V113.99c0-6.9-5.6-12.5-12.5-12.5Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M192.61,174.63h33.2c2.49,0,4.51,2.02,4.51,4.51v201.2h-42.21V179.14c0-2.49,2.02-4.51,4.51-4.51Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M267.27,265.02h33.2c2.49,0,4.51,2.02,4.51,4.51v110.82h-42.21v-110.82c0-2.49,2.02-4.51,4.51-4.51Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M341.93,213.92h33.2c2.49,0,4.51,2.02,4.51,4.51v161.92h-42.21V218.43c0-2.49,2.02-4.51,4.51-4.51Z"
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "h",
					x: 267.83,
					y: 124.71,
					width: 225.76,
					height: 62.79,
					rx: 6.07,
					ry: 6.07
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M294.27,178.86l-20.43-15.66c-1.5-1.15-1.79-3.3-.64-4.81,1.15-1.5,3.3-1.79,4.81-.64l16.4,12.56,25.63-18.41,22.91,7.16,56.11-42.27,32.69,29.84,58.67-58.67c1.34-1.34,3.51-1.34,4.85,0,1.34,1.34,1.34,3.51,0,4.85l-63.3,63.3-33.32-30.42-54.38,40.96-23.01-7.19-26.98,19.38Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M420,416.64H112.9V114.53c0-1.89,1.53-3.43,3.43-3.43s3.43,1.53,3.43,3.43V409.79H420c1.89,0,3.43,1.53,3.43,3.43s-1.53,3.43-3.43,3.43Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "i",
					d: "M439.62,273.4c-9.31-12.77-24.37-21.06-41.38-21.06h0c-28.27,0-51.18,22.92-51.18,51.18,0,12.91,4.78,24.71,12.68,33.71,9.38,10.71,23.15,17.47,38.51,17.47,25.29,0,46.29-18.34,50.44-42.45,.49-2.84,.75-5.76,.75-8.73,0-11.26-3.64-21.67-9.8-30.12Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "h",
						d: "M402.28,249.39v54.13l-38.51,30.77c-7.89-9.01-12.68-20.8-12.68-33.71,0-28.27,22.92-51.18,51.18-51.18Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "g",
						d: "M443.66,270.45c-9.31-12.77-24.37-21.06-41.38-21.06v54.13l50.44,5.79c.49-2.84,.75-5.76,.75-8.73,0-11.26-3.64-21.67-9.8-30.12Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M402.28,303.52l-38.51,30.77c9.38,10.71,23.15,17.47,38.51,17.47,25.29,0,46.29-18.34,50.44-42.45l-50.44-5.79Z"
					})
				] }),
				/* @__PURE__ */ _jsx("circle", {
					className: "h",
					cx: 209.21,
					cy: 413.85,
					r: 17.48
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "i",
						x: 62.35,
						y: 141.06,
						width: 100.57,
						height: 88.66,
						rx: 9.59,
						ry: 9.59
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "h",
						x: 57.4,
						y: 136.67,
						width: 100.57,
						height: 88.66,
						rx: 9.45,
						ry: 9.45
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M122.4,173.75h-7.8v-8.2c0-1.23-1-2.24-2.24-2.24h-10.02c-1.23,0-2.24,1-2.24,2.24v8.2h-8.61c-1.23,0-2.24,1-2.24,2.24v10.02c0,1.23,1,2.24,2.24,2.24h8.61v8.2c0,1.23,1,2.24,2.24,2.24h10.02c1.23,0,2.24-1,2.24-2.24v-8.2h7.8c1.23,0,2.24-1,2.24-2.24v-10.02c0-1.23-1-2.24-2.24-2.24Z"
					})
				] }),
				/* @__PURE__ */ _jsx("circle", {
					className: "h",
					cx: 283.87,
					cy: 413.85,
					r: 17.48
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "h",
					cx: 358.53,
					cy: 413.85,
					r: 17.48
				})
			]
		})
	]
});
export default SvgEmptyStateGeneric;
